import PrivacyPolicyUI from './PrivacyPolicyUI';

export default PrivacyPolicyUI;
